@if (productCode) {
  <form [formGroup]="addToCartForm" (submit)="addToCart()">
    @if (((isContactUs && isPriceAvail && isLoggedIn && showQuantity)
      ||(!isContactUs && isPriceAvail && isLoggedIn && showQuantity))) {
      <div class="quantity">
        <label>{{ 'common.basket_page_qty' | cxTranslate }}</label>
        <div class="cx-counter-stock">
          @if (hasStock) {
            <cx-item-counter
              [max]="maxQuantity"
              [control]="$any(addToCartForm.get('quantity'))"
            ></cx-item-counter>
          }
          <span class="info">
            @if (showInventory$ | async) {
              <span>{{ getInventory() }}</span>
            }
            {{
            hasStock
            ? ('addToCart.inStock' | cxTranslate)
            : ('addToCart.outOfStock' | cxTranslate)
            }}</span
            >
          </div>
        </div>
      }
      @if (hasStock) {
        <ng-template
          [cxOutlet]="CartOutlets.ADD_TO_CART_PICKUP_OPTION"
          [(cxComponentRef)]="pickupOptionCompRef"
        ></ng-template>
      }
      @if (hasStock && isLoggedIn && purchasable) {
        <button
          class="add-to-cart-button"
      [ngClass]="
        options?.displayAddToCart
          ? 'btn btn-tertiary'
          : 'btn btn-primary btn-block'
      "
          type="submit"
          [disabled]="quantity <= 0 || quantity > maxQuantity"
          >
          @if (
            options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)
            ) {
            <span
              class="repeat-icon"
              ><cx-icon [type]="iconTypes.REPEAT"></cx-icon
            ></span>
          }
          <span class="fa fa-shopping-cart mr"></span>
          <span class="text_transform"
        attr.aria-label="{{
          options?.addToCartString ?? ('addToCart.addToCart' | cxTranslate)
        }}"
        [ngClass]="
          options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)
            ? 'buyItAgainLink'
            : ''
        "
            >
            {{ options?.addToCartString ?? ('common.text_addToCart' | cxTranslate) }}
          </span>
        </button>
      }
      @if (!isLoggedIn) {
        <button
          class="fs-20 text_transform"
    [ngClass]="
      options?.displayAddToCart
        ? 'btn btn-tertiary'
        : 'btn btn-primary btn-block'
    "
          (click)="redirectLogin()"
          >
          <span>
            {{ 'common.pdp_page_sign_in' | cxTranslate }}
          </span>
        </button>
      }
    </form>
  }
